/** @format */

import { ReactElement, PropsWithChildren } from "react";
import { useAppSelector } from "../app/hooks";
import { UserRole, UserSubRole } from "../app/services/userApi";

export type AuthFlagProps = {
  roles: UserRole | UserRole[];
  subRoles?: UserSubRole | UserSubRole[];
  fallback?: ReactElement;
};

const AuthFlag: React.FC<PropsWithChildren<AuthFlagProps>> = ({
  children,
  roles,
  subRoles,
  fallback,
}) => {
  const acceptedRoles: UserRole[] = !!Array.isArray(roles) ? roles : [roles];

  const acceptedSubRoles: UserSubRole[] =
    subRoles === undefined
      ? [undefined] // if no subRoles are checked, it is an undefined list
      : !!Array.isArray(subRoles)
        ? subRoles
        : [subRoles];

  const isPending = useAppSelector((state) => state.auth.isPending);
  const role = useAppSelector((state) => state.auth.userInfo?.role);
  const subRole = useAppSelector((state) => state.auth.userInfo?.subRole);

  // while user state is pending, don't render the fallback
  if (isPending) return <></>;
  else
    return acceptedRoles.includes(role) &&
      acceptedSubRoles.includes(
        subRoles === undefined
          ? undefined // if no subRoles are checked, match the undefined list
          : subRole,
      ) ? (
      <>{children}</>
    ) : (
      fallback || null
    );
};

export default AuthFlag;
